<template>
  <v-dialog
    v-model="dialog"
    v-if="dialog"
    persistent
    max-width="1500"
    :scrollable="true"
  >
    <v-card class="pa-0" style="height: 100%;">
      <v-card-title>
        <span class="text-h5">
          {{ readOnly ? "Ver " : beneficiarioId ? "Editar " : "Crear " }}
          Familiar</span
        >
      </v-card-title>
      <v-card-text style="padding: 20px;">
        <!-- <v-alert v-if="errorValidacion" type="error" dense class="mb-4">
          {{ errorValidacion }}
        </v-alert> -->
        <CreateBeneficiarioForm
          :toSave="toSave"
          :product="product" :alianzaId="alianzaId"
          :beneficioEdicion="beneficioEdicion"
          :beneficiariosList="beneficiarios"
          :beneficiarioId="beneficiarioId"
          :readOnly="readOnly"
          @goTosave="goTosave"
          :currentPorcentaje="currentPorcentaje"
          @form-updated="formData = $event"
          :limiteFam="limiteFam"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined rounded color="#00a7e4" @click="$emit('closeModal')">
          <h4>
            Cerrar
          </h4>
        </v-btn>
        <v-btn
          color="#00a7e4"
          class="common-botton"
          @click="toSave = true"
          v-if="!readOnly"
          :disabled="deshabilitarGuardar"
        >
          <h4 style="color: white;">
            Guardar
          </h4>
        </v-btn>
      </v-card-actions>
      <CommonActionModal
        :dialog="dialogEleccion"
        title="Creación de Familiar"
        subtitle="¿Deseas crear el familiar?"
        bottonText="Si, crealo"
        @userChoice="postPutBeneficiario"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CreateBeneficiarioForm from "@/views/pages/hub/beneficiarios/Create/CreateBeneficiarioForm.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import {
  postCrearBeneficiario,
  getBeneficiarioById,
  putEditarBeneficiario,
} from "@/services/beneficiarios/benefiario.service.js";
export default {
  props: {
    beneficiarios: Array,
    dialog: {
      type: Boolean,
      default: true,
    },
    emision_id: {
      type: String,
      default: null,
    },
    alianzaId: {
      type: Number,
      default: null,
    },
    product: {
      type: Object,
      default: null,
    },
    beneficiarioId: {
      type: Number,
      default: null,
    },
    currentPorcentaje: {
      type: Number,
      default: 100,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    solicitud_id: {
      type: String,
      default: null,
    },
    cerrarEvento: {
      type: Boolean,
      default: false,
    },
    limiteFam: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CreateBeneficiarioForm,
    CommonActionModal,
  },
  data() {
    return {
      toSave: false,
      dialogEleccion: false,
      form: {},
      beneficioEdicion: {},
      formData: {},
      errorValidacion: ""
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        return this.getBeneficiarioById();
      }
    },
  },
  methods: {
    goTosave(result, form) {
      if (result) this.dialogEleccion = true;
      this.form = form;
      this.toSave = false;
    },
    async getBeneficiarioById() {
      if (this.beneficiarioId) {
        const beneficiario = await getBeneficiarioById(this.beneficiarioId);
        this.beneficioEdicion = {
          nombre: beneficiario.data.beneficiario.nombre,
          apellido_paterno: beneficiario.data.beneficiario.apellidoPaterno,
          apellido_materno: beneficiario.data.beneficiario.apellidoMaterno,
          fecha_nacimiento: beneficiario.data.beneficiario.fechaNacimiento,
          genero: beneficiario.data.beneficiario.genero,
          estado_civil: beneficiario.data.beneficiario.estadoCivil,
          rfc: beneficiario.data.beneficiario.rfc,
          correo: beneficiario.data.beneficiario.correo,
          telefono: beneficiario.data.beneficiario.telefono,
          parentesco: beneficiario.data.beneficiario.parentesco != null
            ? Number(beneficiario.data.beneficiario.parentesco)
            : null,
          otroParentesco: JSON.parse(beneficiario.data.beneficiario.json).otroParentesco,
          porcentaje: beneficiario.data.beneficiario.porcentaje,  
          es_beneficiario: beneficiario.data.beneficiario.es_beneficiario,
          es_familiar: beneficiario.data.beneficiario.es_familiar,
          status: beneficiario.data.beneficiario.status
        
        };
      }
    },
    postPutBeneficiario(val) {
      this.dialogEleccion = false;
      if (val) {
        if (!this.beneficiarioId) this.postCrearBeneficiario();
        else this.putEditarBeneficiario();
      }
    },
    async postCrearBeneficiario() {
      const finalform = {
        ...this.form,
        ...(this.emision_id && this.emision_id != null && this.emision_id != '' &&  { emision_id: Number(this.emision_id) }),
        ...(this.solicitud_id  && this.solicitud_id != null && this.solicitud_id != '' && { solicitud_id: Number(this.solicitud_id) }),
        porcentaje: Number(this.form.porcentaje),
        parentesco: Number(this.form.parentesco),
      };
      if (this.form.otroParentesco) {
        delete finalform.parentesco;
      }
      
      // if (!this.form.es_familiar && !this.form.es_beneficiario) {
      //   this.errorValidacion = "Debe marcar al menos '¿Es familiar?' o '¿Es beneficiario?'"
      //   return false
      // }
      this.errorValidacion = ""

      try {
        const response = await postCrearBeneficiario(finalform);
        if (response.success) {
          this.$toast.success("Familiar creado con éxito");
          this.$emit("closeModal");
          if(!this.cerrarEvento)
            this.$router.go();
        } else {
          this.$toast.error(
            response.message || "Ocurrió un error al crear el familiar"
          );
          this.dialogEleccion = false;
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
        this.dialogEleccion = false;
      }
    },
    async putEditarBeneficiario() {
      const finalform = {
        ...this.form,
        ...(this.emision_id && this.emision_id !== '' && { emision_id: Number(this.emision_id) }),
        ...(this.solicitud_id && this.solicitud_id !== '' && { solicitud_id: Number(this.solicitud_id) }),
        porcentaje: this.form.status === 2 ? 0 : Number(this.form.porcentaje),
        parentesco: Number(this.form.parentesco),
      };

      if (this.form.otroParentesco) {
        delete finalform.parentesco;
      }

      // if (!this.form.es_familiar && !this.form.es_beneficiario) {
      //   this.errorValidacion = "Debe marcar al menos '¿Es familiar?' o '¿Es beneficiario?'"
      //   return false
      // }
      this.errorValidacion = "" 
      try {
        const response = await putEditarBeneficiario(
          this.beneficiarioId,
          finalform
        );
        if (response.success) {
          this.$toast.success("Familiar editado con éxito");
          this.$emit("getBeneficiarios");
          this.$router.go();
        } else {
          this.$toast.error(
            response.message || "Ocurrió un error al editar el familiar"
          );
          this.dialogEleccion = false;
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
        this.dialogEleccion = false;
      }
    },
  },
  computed: {
    deshabilitarGuardar() {
      const form = this.formData;

      let maxPorcentaje;
      if (!this.beneficiarioId) {
        maxPorcentaje = 100 - this.currentPorcentaje;
      } else {
        const restante = 100 - this.currentPorcentaje;
        maxPorcentaje = Number(this.beneficioEdicion.porcentaje) + Number(restante);
      }

      const porcentajeInvalido = 
        !form.porcentaje || 
        Number(form.porcentaje) <= 0 ||
        Number(form.porcentaje) > maxPorcentaje;

      return (
        form.es_beneficiario === true &&
        form.status === 1 &&
        porcentajeInvalido
      );
    }
  }
};
</script>
